<div class="width-1100">

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>people_outline</mat-icon>
        <div>Usuários</div>
      </div>

      <div flex justify-content='flex-end' fxLayoutAlign="end">
        <input class='filter' matInput (keyup)="applyFilter($event.target.value)" placeholder='filtro'
          autocomplete="off">

        <a mat-button (click)="openDialog(null)" style='width:60px; margin-left:10px;'>
          <mat-icon color='primary'>add_circle_outline</mat-icon>
        </a>


        <a mat-button [matMenuTriggerFor]="menu_export" style='width:60px; margin-left:10px;'>
          <mat-icon class='icon_close'> more_vert</mat-icon>
        </a>

        <mat-menu #menu_export="matMenu" yPosition='below' xPosition='before'>

          <a mat-menu-item (click)='exportToCsv()' target="_blank">
            <mat-icon>arrow_circle_down</mat-icon><span class="nav-caption">Exp Usuários</span>
          </a>

          <a mat-menu-item (click)='annotationsToCSV()' target="_blank">
            <mat-icon>arrow_circle_down</mat-icon><span class="nav-caption">Exp Anotações</span>
          </a>

          <a mat-menu-item (click)='categoriesToCSV()' target="_blank">
            <mat-icon>arrow_circle_down</mat-icon><span class="nav-caption">Exp Categorias</span>
          </a>

          <a mat-menu-item (click)='linksToCSV()' target="_blank">
            <mat-icon>arrow_circle_down</mat-icon><span class="nav-caption">Exp Links</span>
          </a>

        </mat-menu>

      </div>

    </mat-toolbar>
  </mat-card>

  <mat-card style="padding: 5x;">

    <!-- TABLE -->
    <mat-table [dataSource]="dataSource" matSort matSortActive="name" matSortDirection='asc' matSortDisableClear=true>

      <!-- Icon Column -->
      <ng-container matColumnDef="icon">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-icon style='font-size:1.2em; margin-top:10px;' [ngClass]="{'contacted':element.contacted}">people_outline
          </mat-icon>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Nome </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span>
            {{ element.name }}
          </span>
          <span *ngIf="element.gn1">
            (*)
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="subCategory">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Categoria </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span *ngIf="element.subCategory">
            {{ element.subCategory.name }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="annuity_from">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Vigência </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.annuity_from }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="situation">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span *ngIf='element.situation == "0"'>
            <img src='/assets/images/status/img_green.png'>
          </span>

          <span *ngIf='element.situation == "1"'>
            <img src='/assets/images/status/img_red.png'>
          </span>

          <span *ngIf='element.situation == "2"'>
            <img src='/assets/images/status/img_gray.png'>
          </span>

        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="staff">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Staff </mat-header-cell>
        <mat-cell *matCellDef="let element">

          <span *ngIf='element.staff'>
            <img src='/assets/images/status/img_blue.png'>
          </span>

          <span *ngIf='!element.staff'>
            <img src='/assets/images/status/img_white.png'>
          </span>

        </mat-cell>
      </ng-container>


      <ng-container matColumnDef="balance">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Débito </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.balance | currency:'BRL':'':'1.2-2' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="credit">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Crédito </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.credit | currency:'BRL':'':'1.2-2' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="zzversion">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Versão </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.zzversion }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="push">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Push </mat-header-cell>
        <mat-cell *matCellDef="let element">

          <span *ngIf='element.push'>
            <img src='/assets/images/status/img_green.png'>
          </span>

          <span *ngIf='!element.push'>
            <img src='/assets/images/status/img_white.png'>
          </span>

        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="mkt">
        <mat-header-cell *matHeaderCellDef mat-sort-header> MKT </mat-header-cell>
        <mat-cell *matCellDef="let element">

          <div *ngIf='element.sitePolicySigned'>

            <div *ngIf='element.sitePolicySigned.acceptPolicy'>
              <img src='/assets/images/status/img_green.png'>
            </div>

            <div *ngIf='element.sitePolicySigned.acceptEmail'>
              <img src='/assets/images/status/img_green.png'>
            </div>
            <div *ngIf='!element.sitePolicySigned.acceptEmail'>
              <img src='/assets/images/status/img_red.png'>
            </div>
          </div>

          <div *ngIf='!element.sitePolicySigned'>
            <img src='/assets/images/status/img_gray.png'>
          </div>

        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="edit2">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">

          <a mat-button (click)='openDialog(element)' style='background-color: whitesmoke;'>
            <mat-icon class='icon-info'>
              info_outline
            </mat-icon>
          </a>

          <!--
          <a mat-button [matMenuTriggerFor]="member_options" style='background-color: whitesmoke;'>
            <mat-icon class='icon-email'>
              more_vert
            </mat-icon>
          </a>
          <mat-menu #member_options="matMenu" yPosition='below' xPosition='before'>

              <a mat-menu-item (click)='openDialog(element)'>
                <span>Cadastro</span>
              </a>
              
              <a mat-menu-item (click)='openDialog2(element)'>
                <span>Históricos</span>
              </a>
 
          </mat-menu>
          -->

        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="viewer">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='openViewerDialog(element)' style='background-color: whitesmoke;'>
            <mat-icon class='icon-cancel' style='font-size:1.5em;'>preview
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>


      <!-- Header -->
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

      <!-- Row -->
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>
    <!-- END TABLE -->

  </mat-card>

  <mat-paginator [pageSizeOptions]="[9, 13, 26, 50]"></mat-paginator>

</div>